
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M18.4545 10.7879L18.8788 11.2121L16.6342 13.4567L15.4267 11.8467L15.9067 11.4867L16.6991 12.5433L18.4545 10.7879Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0 9C0 7.89543 0.895431 7 2 7H22C23.1046 7 24 7.89543 24 9V15C24 16.1046 23.1046 17 22 17H2C0.89543 17 0 16.1046 0 15V9ZM5.46007 13.9783L7.09656 9.93317L6.08528 9.52405L4.84368 9.72967L4.46652 10.662L5.56554 10.4906L5.58925 10.5002L4.36188 13.534L5.46007 13.9783ZM9.24131 14.4657L9.51832 15.2717L12.6859 14.1831L12.3784 13.2884L10.7664 13.8424L10.7581 13.8183L11.0342 13.3629C11.2585 12.9929 11.4234 12.6839 11.5289 12.4358C11.6344 12.1878 11.6933 11.9746 11.7055 11.7961C11.7173 11.6163 11.696 11.4472 11.6415 11.2886C11.5533 11.0321 11.41 10.8313 11.2114 10.6862C11.0142 10.5407 10.776 10.4573 10.4969 10.4361C10.2186 10.4131 9.91425 10.4584 9.58379 10.572C9.26408 10.6819 9.00473 10.8341 8.80574 11.0286C8.60676 11.2232 8.47812 11.4477 8.41985 11.702C8.36157 11.9563 8.38229 12.2286 8.48202 12.5187L9.54593 12.1531C9.50623 12.0376 9.49402 11.9321 9.5093 11.8367C9.52459 11.7414 9.56403 11.6595 9.62763 11.591C9.69257 11.5222 9.77676 11.4699 9.8802 11.4344C9.98363 11.3988 10.0821 11.3883 10.1757 11.4027C10.2688 11.4157 10.3505 11.4523 10.4206 11.5122C10.4922 11.5718 10.5462 11.6546 10.5826 11.7607C10.6159 11.8574 10.626 11.9524 10.6129 12.0455C10.6012 12.1381 10.5713 12.2347 10.5233 12.3354C10.4762 12.4342 10.4161 12.5434 10.3431 12.6632L9.24131 14.4657ZM20 12C20 13.6569 18.6569 15 17 15C15.3431 15 14 13.6569 14 12C14 10.3431 15.3431 9 17 9C18.6569 9 20 10.3431 20 12Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowverificationcodeFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
